import React, { Component } from 'react';
import '../../I18n/i18n';
import {t} from "i18next";

// Import Images
import bgHome from '../../images/main-banner/bg-home.jpg';


class aboutSection extends Component{
	render(){
		return(
			<>

				<div className="main-banner" style={{backgroundImage: "url("+bgHome+")"}}>
					<div className="container inner-content">
						<div className="row align-items-center">
							<div className="col-lg-7 col-md-6 col-sm-7">
								<h1 className="text-primary">{t("title_home")}</h1>
							</div>
						</div>
					</div>
				</div>

			</>
		);
	}
}

export default aboutSection;
